const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "login":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "login",
    reducer: reducer,
};

export default data;
